import { Story } from "inkjs";
import type { Choice } from "@/types";

export class NarrativeEngine {
  private story: Story | null = null;

  loadStory(inkJson: string): void {
    const storyData = JSON.parse(inkJson);
    this.story = new Story(storyData);
  }

  continue(): string | null {
    if (!this.story) return null;

    if (this.story.canContinue) {
      return this.story.Continue();
    }
    return null;
  }

  getChoices(): Choice[] {
    if (!this.story) return [];

    return this.story.currentChoices.map((choice, index) => ({
      text: choice.text,
      index,
    }));
  }

  chooseChoice(index: number): void {
    if (this.story) {
      this.story.ChooseChoiceIndex(index);
    }
  }

  choosePath(path: string): void {
    if (this.story) {
      this.story.ChoosePathString(path);
    }
  }

  setVariable(name: string, value: unknown): void {
    if (this.story) {
      (this.story.variablesState as Record<string, unknown>)[name] = value;
    }
  }

  getVariable(name: string): unknown {
    if (!this.story) return undefined;
    return (this.story.variablesState as Record<string, unknown>)[name];
  }

  getVariables(): Record<string, unknown> {
    if (!this.story) return {};
    return this.story.variablesState as unknown as Record<string, unknown>;
  }

  getStateJson(): string | null {
    if (!this.story) return null;
    return this.story.state.ToJson();
  }

  loadStateJson(stateJson: string): void {
    if (!this.story) return;
    this.story.state.LoadJson(stateJson);
  }

  getCurrentTags(): string[] {
    if (!this.story) return [];
    return this.story.currentTags ?? [];
  }

  hasChoices(): boolean {
    return this.story ? this.story.currentChoices.length > 0 : false;
  }

  canContinue(): boolean {
    return this.story?.canContinue ?? false;
  }

  isComplete(): boolean {
    if (!this.story) return true;
    return !this.story.canContinue && this.story.currentChoices.length === 0;
  }
}
